import { useState, useEffect } from "react";

const LOGO_URL  = "/logo.png";   // → put your PNG in /public/logo.png
const VIDEO_URL = "/demo.mp4";   // → put your MP4 in /public/demo.mp4

// ─────────────────────────────────────────────────────────────────────────────

const NAV_LINKS = [
  { label: "Home",      href: "home"     },
  { label: "Products",  href: "products" },
  { label: "About Us",  href: "about"    },
];

const TEAM = [
  { name: "Thomas Mathew",      role: "Founder & CEO",      initials: "TM", color: "#D30D0D" },
  { name: "Shani Alex",         role: "Co-Founder",          initials: "SA", color: "#0055A4" },
  { name: "Patrick Davis Culas",role: "COO",                 initials: "PD", color: "#D30D0D" },
  { name: "Cherish Joseph",     role: "CFO",                 initials: "CJ", color: "#0055A4" },
  { name: "Sameer Saxena",      role: "Chief Advisor Tech",  initials: "SS", color: "#D30D0D" },
];

const PRODUCTS = [
  {
    icon: "📱", accent: "#D30D0D",
    bg: "linear-gradient(135deg,#1a0505 0%,#3a0a0a 100%)",
    title: "ClaimEase App",
    shortDesc: "AI-powered claim processing at your fingertips.",
    fullDesc: "Register claims, upload documents, and track status in real time. Our AI-powered platform is built for speed, accuracy, and complete transparency — from first report to final resolution.",
    cta: "Download Mobile App", ctaStyle: "primary",
    tags: ["AI-Powered","Real-Time","Mobile"],
  },
  {
    icon: "🛡️", accent: "#0055A4",
    bg: "linear-gradient(135deg,#010e1f 0%,#042a52 100%)",
    title: "AlloyCare Plan",
    shortDesc: "One-year alloy wheel protection for 2W IC customers.",
    fullDesc: "Subscription options available for alloy wheel protection through OEMs and dealerships. Covers accidental damage from unforeseen events, with a single claim during the one-year policy term.",
    cta: "Buy Now", ctaStyle: "secondary",
    tags: ["OEM Partner","1-Year Cover","Single Claim"],
  },
  {
    icon: "📊", accent: "#D30D0D",
    bg: "linear-gradient(135deg,#1a0505 0%,#3a0a0a 100%)",
    title: "Partner Dashboard",
    shortDesc: "Real-time intelligence for dealerships & repair shops.",
    fullDesc: "Enhance operational efficiency with live analytics, automated document workflows, and instant notifications. Simplify everything from intake to settlement with a single unified platform.",
    cta: "Register Here", ctaStyle: "primary",
    tags: ["Analytics","Automated","Unified"],
  },
];

const STATS = [
  { value: "98%",  label: "User Satisfaction" },
  { value: "2.5L", label: "Protected Rides"   },
  { value: "10K+", label: "Claims Processed"  },
  { value: "50+", label: "Partner Dealers"   },
];

const POLICY = {
  privacy: {
    title: "Privacy Policy",
    sections: [
      { h: "1. Information We Collect",   b: "We collect personal information you provide when registering a claim, contacting us, or using our platform — including your name, email, phone number, vehicle details, and uploaded documents. We also collect usage data (IP addresses, browser type, pages visited) to improve our services." },
      { h: "2. How We Use Your Information", b: "Your information is used to process insurance claims, provide customer support, send service-related communications, improve our platform, and comply with legal obligations. We do not sell your personal data to third parties." },
      { h: "3. Data Sharing",             b: "We may share your information with OEM partners, repair workshops, and insurance carriers strictly for claim processing. All third parties are contractually bound to handle your data with equivalent care and security." },
      { h: "4. Data Security",            b: "We implement industry-standard security measures including SSL encryption, secure servers, and access controls. No method of transmission over the internet is 100% secure, but we take all reasonable precautions." },
      { h: "5. Your Rights",              b: "You have the right to access, correct, or delete your personal data at any time. Contact support@suretyfox.in. We respond to all requests within 30 days." },
      { h: "6. Cookies",                  b: "Our website uses cookies to enhance your browsing experience. You may disable cookies in browser settings, though some features may not function correctly." },
      { h: "7. Changes to This Policy",   b: "We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated effective date. Continued use constitutes acceptance of the revised policy." },
      { h: "8. Contact",                  b: "For privacy-related enquiries: support@suretyfox.in or +91 75948 04440 (Mon–Sat, 9AM–7PM)." },
    ],
  },
  terms: {
    title: "Terms of Service",
    sections: [
      { h: "1. Acceptance of Terms",      b: "By accessing or using SuretyFox's platform, products, or services, you agree to be bound by these Terms. If you do not agree, you may not use our services." },
      { h: "2. Eligibility",              b: "Our services are available to individuals who are at least 18 years of age. By using our platform, you represent that you meet this requirement." },
      { h: "3. AlloyCare Plan Coverage",  b: "The AlloyCare Plan provides one-year protection for alloy wheels against accidental damage for eligible 2W IC customers. Coverage is limited to a single claim per policy term. Damage from negligence, intentional misuse, or normal wear and tear is excluded." },
      { h: "4. Claim Processing",         b: "Claims must be filed through the ClaimEase App with accurate information and required documentation. False or incomplete claims may result in denial. SuretyFox reserves the right to verify all submitted information." },
      { h: "5. Partner Dashboard",        b: "Access is granted to registered partner businesses only. Partners are responsible for maintaining the security of their login credentials and all activity under their account." },
      { h: "6. Limitation of Liability",  b: "SuretyFox shall not be liable for any indirect, incidental, or consequential damages. Our total liability shall not exceed the amount paid by you for the relevant service." },
      { h: "7. Intellectual Property",    b: "All content, trademarks, logos, and software on the SuretyFox platform are the property of SuretyFox Tech Private Limited and may not be used without prior written consent." },
      { h: "8. Governing Law",            b: "These Terms are governed by the laws of India. Disputes shall be subject to the exclusive jurisdiction of the courts in Kottayam, Kerala." },
      { h: "9. Contact",                  b: "For questions about these Terms: support@suretyfox.in or +91 75948 04440." },
    ],
  },
};

// ── Animated shield (About section) ──────────────────────────────────────────
function AnimatedShield() {
  return (
    <div style={{ position: "relative", width: "100%" }}>
      <div style={{
        background: "linear-gradient(135deg,#0a0a1a 0%,#0d1f3c 60%,#1a0a0a 100%)",
        borderRadius: 24, aspectRatio: "4/3",
        display: "flex", alignItems: "center", justifyContent: "center",
        overflow: "hidden", position: "relative",
        boxShadow: "0 40px 80px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.05)",
      }}>
        <div style={{ position:"absolute", inset:0, backgroundImage:"linear-gradient(rgba(0,85,164,0.07) 1px,transparent 1px),linear-gradient(90deg,rgba(0,85,164,0.07) 1px,transparent 1px)", backgroundSize:"32px 32px" }} />
        <div style={{ position:"absolute", top:"18%", left:"12%", width:130, height:130, background:"radial-gradient(circle,rgba(211,13,13,0.28) 0%,transparent 70%)", animation:"sfOrb1 3s ease-in-out infinite" }} />
        <div style={{ position:"absolute", bottom:"18%", right:"12%", width:110, height:110, background:"radial-gradient(circle,rgba(0,85,164,0.32) 0%,transparent 70%)", animation:"sfOrb2 4s ease-in-out infinite" }} />
        <div style={{ position:"relative", zIndex:2, textAlign:"center" }}>
          <div style={{ animation:"sfFloat 3s ease-in-out infinite" }}>
            <svg viewBox="0 0 120 140" style={{ width:110, height:128 }} xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="sg1" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#D30D0D"/><stop offset="100%" stopColor="#7a0000"/>
                </linearGradient>
                <filter id="sglow"><feGaussianBlur stdDeviation="3" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
              </defs>
              <path d="M60 8 L108 30 L108 68 C108 96 86 118 60 128 C34 118 12 96 12 68 L12 30 Z" fill="url(#sg1)" filter="url(#sglow)" opacity="0.92"/>
              <path d="M60 20 L96 38 L96 68 C96 90 80 108 60 116 C40 108 24 90 24 68 L24 38 Z" fill="none" stroke="rgba(255,255,255,0.18)" strokeWidth="1.5"/>
              <path d="M40 70 L54 84 L82 56" stroke="#fff" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" fill="none" filter="url(#sglow)"/>
            </svg>
          </div>
          <div style={{ display:"flex", gap:8, justifyContent:"center", flexWrap:"wrap", marginTop:20 }}>
            {["Claim Tracking","Real-Time","OEM Ready","AI Powered"].map((tag,i)=>(
              <span key={tag} style={{ background:"rgba(255,255,255,0.07)", border:"1px solid rgba(255,255,255,0.12)", color:"rgba(255,255,255,0.8)", fontSize:11, fontWeight:600, padding:"4px 12px", borderRadius:999, animation:`sfTagIn 0.5s ease forwards ${i*0.12}s`, opacity:0, backdropFilter:"blur(6px)" }}>{tag}</span>
            ))}
          </div>
        </div>
        <div style={{ position:"absolute", left:0, right:0, height:2, background:"linear-gradient(90deg,transparent,rgba(211,13,13,0.7),transparent)", animation:"sfScan 3s linear infinite", pointerEvents:"none" }} />
      </div>
      <div style={{ position:"absolute", bottom:-22, left:-22, background:"#fff", borderRadius:14, padding:"12px 20px", boxShadow:"0 12px 40px rgba(0,0,0,0.15)", display:"flex", alignItems:"center", gap:12, border:"1px solid rgba(211,13,13,0.08)" }}>
        <div style={{ width:44, height:44, background:"rgba(0,85,164,0.1)", borderRadius:10, display:"flex", alignItems:"center", justifyContent:"center", fontSize:22 }}>🛡️</div>
        <div>
          <p style={{ fontSize:10, color:"#5d3f3b", margin:0, textTransform:"uppercase", letterSpacing:"0.09em", fontWeight:700 }}>Claims Resolved</p>
          <p style={{ fontSize:22, fontWeight:900, color:"#191c1d", margin:0 }}>10,000+</p>
        </div>
      </div>
    </div>
  );
}

// ── Hover-reveal product card ─────────────────────────────────────────────────
function ProductCard({ p, onContact }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={()=>setHovered(true)} onMouseLeave={()=>setHovered(false)}
      style={{
        position:"relative", borderRadius:20, overflow:"hidden", minHeight:340, cursor:"pointer",
        transition:"transform 0.35s cubic-bezier(.25,.8,.25,1), box-shadow 0.35s ease",
        transform: hovered?"translateY(-10px) scale(1.02)":"translateY(0) scale(1)",
        boxShadow: hovered?`0 32px 64px rgba(0,0,0,0.3),0 0 0 2px ${p.accent}`:"0 8px 28px rgba(0,0,0,0.18)",
      }}
    >
      {/* Front */}
      <div style={{ background:p.bg, minHeight:340, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"44px 28px", opacity:hovered?0:1, transition:"opacity 0.28s ease", position:hovered?"absolute":"relative", inset:0 }}>
        <div style={{ position:"absolute", inset:0, backgroundImage:`radial-gradient(circle at 50% 40%,${p.accent}18 0%,transparent 65%)` }}/>
        <div style={{ fontSize:60, marginBottom:18, filter:"drop-shadow(0 0 18px rgba(255,255,255,0.15))", position:"relative", zIndex:1 }}>{p.icon}</div>
        <h3 style={{ fontSize:20, fontWeight:800, color:"#fff", margin:"0 0 10px", textAlign:"center", position:"relative", zIndex:1, letterSpacing:"-0.02em" }}>{p.title}</h3>
        <p style={{ fontSize:13, color:"rgba(255,255,255,0.55)", textAlign:"center", margin:0, position:"relative", zIndex:1, lineHeight:1.65 }}>{p.shortDesc}</p>
        <div style={{ display:"flex", gap:8, marginTop:22, flexWrap:"wrap", justifyContent:"center", position:"relative", zIndex:1 }}>
          {p.tags.map(tag=><span key={tag} style={{ background:`${p.accent}22`, border:`1px solid ${p.accent}50`, color:"rgba(255,255,255,0.75)", fontSize:10, fontWeight:700, padding:"3px 10px", borderRadius:999 }}>{tag}</span>)}
        </div>
        <p style={{ position:"absolute", bottom:14, fontSize:10, color:"rgba(255,255,255,0.25)", letterSpacing:"0.12em", textTransform:"uppercase" }}>Hover to explore →</p>
      </div>
      {/* Back */}
      <div style={{ background:"#fff", minHeight:340, display:"flex", flexDirection:"column", padding:"36px 28px", opacity:hovered?1:0, transition:"opacity 0.28s ease 0.06s", position:hovered?"relative":"absolute", inset:0, borderTop:`4px solid ${p.accent}` }}>
        <div style={{ fontSize:38, marginBottom:14 }}>{p.icon}</div>
        <h3 style={{ fontSize:20, fontWeight:800, color:"#191c1d", marginBottom:12, letterSpacing:"-0.02em" }}>{p.title}</h3>
        <p style={{ fontSize:14, color:"#5d3f3b", lineHeight:1.78, marginBottom:22, flex:1 }}>{p.fullDesc}</p>
        <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginBottom:22 }}>
          {p.tags.map(tag=><span key={tag} style={{ background:`${p.accent}12`, border:`1px solid ${p.accent}28`, color:p.accent, fontSize:10, fontWeight:700, padding:"3px 10px", borderRadius:999 }}>{tag}</span>)}
        </div>
        <button onClick={onContact} style={{
          background: p.ctaStyle==="primary"?"#D30D0D":p.ctaStyle==="secondary"?"#0055A4":"transparent",
          color: p.ctaStyle==="outline"?p.accent:"#fff",
          border: p.ctaStyle==="outline"?`2px solid ${p.accent}`:"none",
          borderRadius:10, padding:"12px 24px", fontWeight:700, fontSize:13,
          cursor:"pointer", fontFamily:"Outfit,sans-serif", width:"100%", transition:"opacity 0.2s,transform 0.2s",
        }}
          onMouseEnter={e=>{e.target.style.opacity="0.83";e.target.style.transform="translateY(-1px)";}}
          onMouseLeave={e=>{e.target.style.opacity="1";e.target.style.transform="translateY(0)";}}
        >{p.cta}</button>
      </div>
    </div>
  );
}

// ── Policy modal ──────────────────────────────────────────────────────────────
function Modal({ title, sections, onClose }) {
  useEffect(()=>{
    const prev=document.body.style.overflow; document.body.style.overflow="hidden";
    return ()=>{ document.body.style.overflow=prev; };
  },[]);
  return (
    <div onClick={onClose} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.6)", zIndex:9000, display:"flex", alignItems:"center", justifyContent:"center", padding:24, backdropFilter:"blur(6px)" }}>
      <div onClick={e=>e.stopPropagation()} style={{ background:"#fff", borderRadius:20, maxWidth:720, width:"100%", maxHeight:"82vh", overflowY:"auto", padding:"48px 48px 40px", position:"relative", boxShadow:"0 40px 80px rgba(0,0,0,0.3)" }}>
        <button onClick={onClose} style={{ position:"absolute", top:20, right:20, background:"#f0f0f0", border:"none", borderRadius:"50%", width:36, height:36, fontSize:20, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", lineHeight:1 }}>×</button>
        <h2 style={{ fontSize:26, fontWeight:900, color:"#191c1d", marginBottom:8, letterSpacing:"-0.02em", fontFamily:"Outfit,sans-serif" }}>{title}</h2>
        <p style={{ fontSize:12, color:"#aaa", marginBottom:32, fontFamily:"Outfit,sans-serif" }}>Last updated: January 2025 · SuretyFox Tech Private Limited</p>
        {sections.map(s=>(
          <div key={s.h} style={{ marginBottom:24 }}>
            <h3 style={{ fontSize:15, fontWeight:700, color:"#191c1d", marginBottom:8, fontFamily:"Outfit,sans-serif" }}>{s.h}</h3>
            <p style={{ fontSize:14, color:"#5d3f3b", lineHeight:1.85, fontFamily:"Outfit,sans-serif" }}>{s.b}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── Main ──────────────────────────────────────────────────────────────────────
export default function SuretyFoxWebsite() {
  const [menuOpen,  setMenuOpen]  = useState(false);
  const [scrolled,  setScrolled]  = useState(false);
  const [logoError, setLogoError] = useState(false);
  const [modal,     setModal]     = useState(null); // "privacy" | "terms" | null
  const [formData,  setFormData]  = useState({ firstName:"", lastName:"", email:"", message:"" });
  const [submitted, setSubmitted] = useState(false);

  useEffect(()=>{
    const h=()=>setScrolled(window.scrollY>20);
    window.addEventListener("scroll",h); return ()=>window.removeEventListener("scroll",h);
  },[]);

  const scrollTo=(id)=>{ document.getElementById(id)?.scrollIntoView({behavior:"smooth"}); setMenuOpen(false); };

  const handleSubmit=(e)=>{ e.preventDefault(); setSubmitted(true); setTimeout(()=>setSubmitted(false),4000); setFormData({firstName:"",lastName:"",email:"",message:""}); };

  // ── input style helper
  const inp={
    width:"100%", padding:"12px 14px", border:"1.5px solid #e7e8e9",
    borderRadius:10, fontSize:14, outline:"none",
    fontFamily:"Outfit,sans-serif", transition:"border 0.2s",
  };

  return (
    <>
      {/* ── GLOBAL CSS ──────────────────────────────────────────────────────── */}
      <style>{`
        *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
        html{scroll-behavior:smooth;}
        html,body,#root{width:100%;overflow-x:hidden;}
        body{font-family:'Outfit',sans-serif;background:#f0f7ff;}

        @keyframes sfOrb1 {0%,100%{transform:scale(1);opacity:.6}50%{transform:scale(1.3);opacity:1}}
        @keyframes sfOrb2 {0%,100%{transform:scale(1);opacity:.5}50%{transform:scale(1.4);opacity:.9}}
        @keyframes sfFloat{0%,100%{transform:translateY(0)}50%{transform:translateY(-12px)}}
        @keyframes sfScan {0%{top:0}100%{top:100%}}
        @keyframes sfTagIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}
        @keyframes sfUp   {from{opacity:0;transform:translateY(22px)}to{opacity:1;transform:translateY(0)}}
        @keyframes sfPulse{0%,100%{opacity:1}50%{opacity:.35}}

        .sf-up{animation:sfUp 0.65s ease both;}
        .sf-d1{animation-delay:.05s}.sf-d2{animation-delay:.14s}
        .sf-d3{animation-delay:.23s}.sf-d4{animation-delay:.32s}

        @media(max-width:900px){.sf-dnav{display:none!important}.sf-ham{display:flex!important}}
        @media(max-width:768px){
          .sf-hg{grid-template-columns:1fr!important}
          .sf-pg{grid-template-columns:1fr!important}
          .sf-ag{grid-template-columns:1fr!important}
          .sf-tg{grid-template-columns:repeat(2,1fr)!important}
          .sf-sg{grid-template-columns:repeat(2,1fr)!important}
          .sf-cg{grid-template-columns:1fr!important}
          .sf-fi{flex-direction:column!important;align-items:flex-start!important;gap:20px!important}
          .sf-cp{padding:40px 28px!important}
        }
      `}</style>

      <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800;900&display=swap" rel="stylesheet"/>

      {/* ── NAVBAR ─────────────────────────────────────────────────────────── */}
      <nav style={{
        position:"fixed", top:0, left:0, width:"100%", zIndex:1000,
        background: scrolled?"rgba(204, 203, 215, 0.97)":"rgba(255,255,255,0.92)",
        backdropFilter:"blur(16px)",
        borderBottom: scrolled?"1px solidrgb(118, 104, 104)":"1px solid transparent",
        boxShadow: scrolled?"0 4px 24px rgba(0,0,0,0.07)":"none",
        transition:"all 0.35s ease",
      }}>
        <div style={{ width:"100%", padding:"0 5%", display:"flex", alignItems:"center", justifyContent:"space-between", height:70 }}>
          {/* Logo */}
          <button onClick={()=>scrollTo("home")} style={{ background:"none", border:"none", cursor:"pointer", padding:0, display:"flex", alignItems:"center" }}>
            {!logoError
              ? <img src={LOGO_URL} alt="SuretyFox" style={{ height:95, width:"auto", objectFit:"contain" }} onError={()=>setLogoError(true)}/>
              : <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                  <div style={{ width:38, height:38, background:"linear-gradient(135deg,#D30D0D,#a70004)", borderRadius:8, display:"flex", alignItems:"center", justifyContent:"center" }}>
                    <span style={{ color:"#fff", fontWeight:900, fontSize:20 }}>S</span>
                  </div>
                  <span style={{ fontWeight:900, fontSize:20, color:"#D30D0D", fontFamily:"Outfit,sans-serif" }}>SURETY</span>
                  <span style={{ fontWeight:900, fontSize:20, color:"#0055A4", fontFamily:"Outfit,sans-serif" }}>FOX</span>
                </div>
            }
          </button>
          {/* Links */}
          <div style={{ display:"flex", alignItems:"center", gap:40 }}>
            <div className="sf-dnav" style={{ display:"flex", gap:36 }}>
              {NAV_LINKS.map(l=>(
                <button key={l.href} onClick={()=>scrollTo(l.href)} style={{ background:"none", border:"none", cursor:"pointer", fontSize:14, fontWeight:600, color:"#4a4a4a", letterSpacing:"0.02em", padding:"6px 0", borderBottom:"2px solid transparent", transition:"color 0.2s,border-color 0.2s", fontFamily:"Outfit,sans-serif" }}
                  onMouseEnter={e=>{e.target.style.color="#D30D0D";e.target.style.borderBottomColor="#D30D0D";}}
                  onMouseLeave={e=>{e.target.style.color="#4a4a4a";e.target.style.borderBottomColor="transparent";}}
                >{l.label}</button>
              ))}
            </div>
            <button onClick={()=>scrollTo("contact")} style={{ background:"linear-gradient(135deg,#D30D0D,#a70004)", color:"#fff", border:"none", borderRadius:10, padding:"10px 26px", fontWeight:700, fontSize:14, cursor:"pointer", fontFamily:"Outfit,sans-serif", boxShadow:"0 4px 16px rgba(211,13,13,0.3)", transition:"transform 0.25s,box-shadow 0.25s" }}
              onMouseEnter={e=>{e.target.style.transform="translateY(-2px)";e.target.style.boxShadow="0 10px 28px rgba(211,13,13,0.42)";}}
              onMouseLeave={e=>{e.target.style.transform="translateY(0)";e.target.style.boxShadow="0 4px 16px rgba(211,13,13,0.3)";}}
            >Contact Us</button>
            {/* Hamburger */}
            <button className="sf-ham" onClick={()=>setMenuOpen(!menuOpen)} style={{ background:"none", border:"none", cursor:"pointer", display:"none", flexDirection:"column", gap:5, padding:4 }}>
              {[0,1,2].map(i=><span key={i} style={{ display:"block", width:24, height:2, background:"#191c1d", borderRadius:2 }}/>)}
            </button>
          </div>
        </div>
        {menuOpen&&(
          <div style={{ background:"#fff", borderTop:"1px solid #eee", padding:"16px 5%", display:"flex", flexDirection:"column", gap:4 }}>
            {NAV_LINKS.map(l=>(
              <button key={l.href} onClick={()=>scrollTo(l.href)} style={{ background:"none", border:"none", cursor:"pointer", textAlign:"left", padding:"12px 0", fontSize:15, fontWeight:600, color:"#191c1d", fontFamily:"Outfit,sans-serif", borderBottom:"1px solid #f0f0f0" }}>{l.label}</button>
            ))}
            <button onClick={()=>scrollTo("contact")} style={{ marginTop:8, background:"#D30D0D", color:"#fff", border:"none", borderRadius:8, padding:"12px 24px", fontWeight:700, fontSize:14, cursor:"pointer", fontFamily:"Outfit,sans-serif" }}>Contact Us</button>
          </div>
        )}
      </nav>

      {/* ── HERO ───────────────────────────────────────────────────────────── */}
      <section id="home" style={{
        width:"100vw", minHeight:"100vh", paddingTop:70,
        background:"linear-gradient(160deg,#080814 0%,#0c1c38 45%,#180508 100%)",
        display:"flex", alignItems:"center", position:"relative", overflow:"hidden",
      }}>
        <div style={{ position:"absolute", inset:0, backgroundImage:"radial-gradient(ellipse at 20% 55%,rgba(211,13,13,0.13) 0%,transparent 58%),radial-gradient(ellipse at 80% 30%,rgba(0,85,164,0.16) 0%,transparent 58%)" }}/>
        <div style={{ position:"absolute", inset:0, backgroundImage:"linear-gradient(rgba(255,255,255,0.02) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,0.02) 1px,transparent 1px)", backgroundSize:"52px 52px" }}/>

        <div style={{ width:"100%", padding:"80px 5%", position:"relative", zIndex:1 }}>
          <div className="sf-hg" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:64, alignItems:"center" }}>
            {/* Left */}
            <div>
              <span className="sf-up sf-d1" style={{ display:"inline-flex", alignItems:"center", gap:8, background:"rgba(211,13,13,0.14)", color:"#ff7070", fontSize:11, fontWeight:700, letterSpacing:"0.14em", padding:"7px 16px", borderRadius:999, marginBottom:28, textTransform:"uppercase", border:"1px solid rgba(211,13,13,0.24)" }}>
                <span style={{ width:6, height:6, background:"#ff7070", borderRadius:"50%", display:"inline-block", animation:"sfPulse 1.8s ease-in-out infinite" }}/>
                Reliability at Speed
              </span>
              <h1 className="sf-up sf-d2" style={{ fontSize:"clamp(36px,4.8vw,60px)", fontWeight:900, lineHeight:1.04, letterSpacing:"-0.04em", color:"#fff", marginBottom:24, textTransform:"uppercase" }}>
                Stress-Free<br/><span style={{ color:"#D30D0D" }}>Claims</span> Handling.
              </h1>
              <p className="sf-up sf-d3" style={{ fontSize:17, lineHeight:1.78, color:"rgba(255,255,255,0.6)", marginBottom:40, maxWidth:500 }}>
                We help you handle claims faster with less stress. Streamlined documents, real-time tracking, and full transparency — so every ride stays protected.
              </p>
              <div className="sf-up sf-d4" style={{ display:"flex", gap:16, flexWrap:"wrap" }}>
                <button onClick={()=>scrollTo("products")} style={{ background:"linear-gradient(135deg,#D30D0D,#a70004)", color:"#fff", border:"none", borderRadius:12, padding:"14px 36px", fontWeight:700, fontSize:15, cursor:"pointer", fontFamily:"Outfit,sans-serif", boxShadow:"0 8px 24px rgba(211,13,13,0.35)", transition:"transform 0.25s,box-shadow 0.25s" }}
                  onMouseEnter={e=>{e.target.style.transform="translateY(-3px)";e.target.style.boxShadow="0 16px 36px rgba(211,13,13,0.45)";}}
                  onMouseLeave={e=>{e.target.style.transform="translateY(0)";e.target.style.boxShadow="0 8px 24px rgba(211,13,13,0.35)";}}
                >Explore Products</button>
                <button onClick={()=>scrollTo("contact")} style={{ background:"rgba(255,255,255,0.07)", color:"#fff", border:"1.5px solid rgba(255,255,255,0.22)", borderRadius:12, padding:"13px 34px", fontWeight:700, fontSize:15, cursor:"pointer", fontFamily:"Outfit,sans-serif", transition:"background 0.25s,border-color 0.25s" }}
                  onMouseEnter={e=>{e.target.style.background="rgba(255,255,255,0.14)";e.target.style.borderColor="rgba(255,255,255,0.4)";}}
                  onMouseLeave={e=>{e.target.style.background="rgba(255,255,255,0.07)";e.target.style.borderColor="rgba(255,255,255,0.22)";}}
                >Request a Demo</button>
              </div>
            </div>

            {/* Right – video */}
            <div className="sf-up sf-d3" style={{ position:"relative" }}>
              <div style={{ borderRadius:20, overflow:"hidden", boxShadow:"0 40px 80px rgba(0,0,0,0.55),0 0 0 1px rgba(255,255,255,0.06)", aspectRatio:"16/10", background:"#000", position:"relative" }}>
                <video src={VIDEO_URL} autoPlay muted loop playsInline style={{ width:"100%", height:"100%", objectFit:"cover", display:"block" }}/>
                <div style={{ position:"absolute", inset:0, background:"linear-gradient(to top,rgba(0,0,0,0.48) 0%,transparent 55%)", pointerEvents:"none" }}/>
                <div style={{ position:"absolute", bottom:16, left:16, display:"flex", alignItems:"center", gap:8 }}>
                  <span style={{ width:8, height:8, borderRadius:"50%", background:"#ff4444", display:"inline-block", animation:"sfPulse 1.5s ease-in-out infinite" }}/>
                  <span style={{ color:"#fff", fontSize:12, fontWeight:600, letterSpacing:"0.1em" }}>LIVE DEMO</span>
                </div>
              </div>
              <div style={{ position:"absolute", bottom:-22, left:-22, background:"#fff", borderRadius:14, padding:"12px 20px", boxShadow:"0 12px 40px rgba(0,0,0,0.2)", display:"flex", alignItems:"center", gap:12 }}>
                <div style={{ width:44, height:44, background:"rgba(0,85,164,0.1)", borderRadius:10, display:"flex", alignItems:"center", justifyContent:"center", fontSize:22 }}>🛡️</div>
                <div>
                  <p style={{ fontSize:10, color:"#5d3f3b", margin:0, textTransform:"uppercase", letterSpacing:"0.09em", fontWeight:700 }}>Claims Resolved</p>
                  <p style={{ fontSize:22, fontWeight:900, color:"#191c1d", margin:0 }}>10,000+</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── STATS ──────────────────────────────────────────────────────────── */}
      <div style={{ width:"100vw", background:"linear-gradient(135deg,#0055A4,#003370)", padding:"44px 5%" }}>
        <div className="sf-sg" style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:24 }}>
          {STATS.map(s=>(
            <div key={s.label} style={{ textAlign:"center" }}>
              <p style={{ fontSize:42, fontWeight:900, color:"#fff", margin:0, letterSpacing:"-0.03em" }}>{s.value}</p>
              <p style={{ fontSize:12, color:"rgba(255,255,255,0.6)", margin:"6px 0 0", textTransform:"uppercase", letterSpacing:"0.1em" }}>{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* ── PRODUCTS ───────────────────────────────────────────────────────── */}
      <section id="products" style={{ width:"100vw", padding:"100px 5%", background:"#0a0a14" }}>
        <div style={{ textAlign:"center", marginBottom:64 }}>
          <span style={{ color:"#ff7070", fontSize:11, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase" }}>Our Solutions</span>
          <h2 style={{ fontSize:"clamp(30px,3.5vw,46px)", fontWeight:900, color:"#fff", marginTop:10, letterSpacing:"-0.03em" }}>Our Products</h2>
          <p style={{ color:"rgba(255,255,255,0.48)", fontSize:16, maxWidth:520, margin:"14px auto 0", lineHeight:1.78 }}>Integrated solutions bridging riders, repair shops, and insurance carriers.</p>
        </div>
        <div className="sf-pg" style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:24 }}>
          {PRODUCTS.map(p=><ProductCard key={p.title} p={p} onContact={()=>scrollTo("contact")}/>)}
        </div>
      </section>

      {/* ── ABOUT ──────────────────────────────────────────────────────────── */}
      <section id="about" style={{ width:"100vw", padding:"100px 5%", background:"#f0f7ff" }}>
        <div className="sf-ag" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:80, alignItems:"center" }}>
          <AnimatedShield/>
          <div>
            <span style={{ color:"#D30D0D", fontSize:11, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase" }}>About SuretyFox</span>
            <h3 style={{ fontSize:"clamp(28px,3vw,42px)", fontWeight:500, color:"#191c1d", marginTop:10, marginBottom:20, letterSpacing:"-0.03em", lineHeight:1.12 }}>
              Learn more About Us and Our Commitment to Protection
            </h3>
            <p style={{ fontSize:16, color:"#5d3f3b", lineHeight:1.88, marginBottom:18 }}><h3>Our Mission</h3><br/>To provide innovative and accessible protection solutions that give vehicle owners peace of mind while ensuring a seamless claims experience through cutting-edge technology.</p>
            <p style={{ fontSize:16, color:"#5d3f3b", lineHeight:1.88, marginBottom:40 }}><h3>Our Vision</h3><br/>To become the most trusted vehicle protection partner, known for our commitment to customer satisfaction, technological innovation, and operational excellence.</p>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:24 }}>
              {STATS.slice(0,2).map(s=>(
                <div key={s.label} style={{ borderLeft:"4px solid #D30D0D", paddingLeft:18 }}>
                  <p style={{ fontSize:38, fontWeight:900, color:"#D30D0D", margin:0, letterSpacing:"-0.03em" }}>{s.value}</p>
                  <p style={{ fontSize:11, color:"#5d3f3b", margin:"4px 0 0", textTransform:"uppercase", letterSpacing:"0.1em", fontWeight:600 }}>{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── LEADERSHIP ─────────────────────────────────────────────────────── */}
      <section style={{ width:"100vw", padding:"100px 5%", background:"#fff" }}>
        <div style={{ textAlign:"center", marginBottom:64 }}>
          <span style={{ color:"#D30D0D", fontSize:11, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase" }}>Our Expertise</span>
          <h2 style={{ fontSize:"clamp(28px,3vw,42px)", fontWeight:900, color:"#191c1d", marginTop:10, letterSpacing:"-0.03em" }}>Meet Our Leadership</h2>
          <p style={{ color:"#5d3f3b", fontSize:16, maxWidth:480, margin:"14px auto 0", lineHeight:1.78 }}>The visionary team behind SuretyFox, dedicated to modernizing insurance.</p>
        </div>
        <div className="sf-tg" style={{ display:"grid", gridTemplateColumns:"repeat(5,1fr)", gap:24 }}>
          {TEAM.map(m=>(
            <div key={m.name} style={{ textAlign:"center", transition:"transform 0.3s ease" }}
              onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-8px)";}}
              onMouseLeave={e=>{e.currentTarget.style.transform="translateY(0)";}}
            >
              <div style={{ background:m.color==="#D30D0D"?"linear-gradient(135deg,#1a0505,#3a0a0a)":"linear-gradient(135deg,#010e1f,#042a52)", borderRadius:16, aspectRatio:"4/5", display:"flex", alignItems:"center", justifyContent:"center", marginBottom:16, boxShadow:"0 8px 24px rgba(0,0,0,0.12)" }}>
                <div style={{ width:60, height:60, borderRadius:"50%", background:`${m.color}22`, border:`2px solid ${m.color}55`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:20, fontWeight:800, color:"#fff", fontFamily:"Outfit,sans-serif" }}>{m.initials}</div>
              </div>
              <h4 style={{ fontSize:14, fontWeight:700, color:"#191c1d", margin:"0 0 4px", lineHeight:1.3, fontFamily:"Outfit,sans-serif" }}>{m.name}</h4>
              <p style={{ fontSize:11, fontWeight:700, color:"#D30D0D", margin:0, textTransform:"uppercase", letterSpacing:"0.07em", fontFamily:"Outfit,sans-serif" }}>{m.role}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── CONTACT ────────────────────────────────────────────────────────── */}
      <section id="contact" style={{ width:"100vw", padding:"100px 5%", background:"#f0f7ff" }}>
        <div className="sf-cg" style={{ borderRadius:24, overflow:"hidden", boxShadow:"0 40px 80px rgba(0,0,0,0.12)", display:"grid", gridTemplateColumns:"1fr 1fr" }}>
          {/* Left panel */}
          <div className="sf-cp" style={{ background:"linear-gradient(160deg,#0055A4,#003266)", padding:"60px 52px" }}>
            <h2 style={{ fontSize:"clamp(26px,2.5vw,36px)", fontWeight:900, color:"#fff", marginBottom:14, lineHeight:1.18, letterSpacing:"-0.02em" }}>Let's Secure Your Future.</h2>
            <p style={{ color:"rgba(255,255,255,0.68)", fontSize:15, marginBottom:44, lineHeight:1.82 }}>Looking for coverage or wanting to modernize your workflow? Our team is ready to assist.</p>
            {[
              { icon:"✉️", label:"Email Us",       value:"support@suretyfox.in"                                                                      },
              { icon:"📞", label:"Call Us",        value:"+91 75948 04440\n9:00AM – 7:00PM, Mon–Sat"                                                  },
              { icon:"📍", label:"Headquarters",   value:"403/I, Pandarakunnel Building,\nManarcad, Thengana Rd,\nPuthupally, Kottayam – KL 686011"   },
            ].map(item=>(
              <div key={item.label} style={{ display: "flex", gap: 16, marginBottom: 28, textAlign: "left" }}>
                <div style={{ width:46, height:46, background:"rgba(255,255,255,0.1)", borderRadius:12, display:"flex", alignItems:"center", justifyContent:"center", fontSize:20, flexShrink:0 }}>{item.icon}</div>
                <div>
                  <p style={{ fontSize:11, fontWeight:700, letterSpacing:"0.1em", color:"rgba(180,210,255,0.88)", margin:"0 0 4px", textTransform:"uppercase" }}>{item.label}</p>
                  <p style={{ fontSize:14, color:"#fff", margin:0, lineHeight:1.68, whiteSpace:"pre-line" }}>{item.value}</p>
                </div>
              </div>
            ))}

          </div>
          {/* Right form */}
          <div className="sf-cp" style={{ background:"#fff", padding:"60px 52px" }}>
            {submitted?(
              <div style={{ height:"100%", display:"flex", alignItems:"flex-start", justifyContent:"center", flexDirection:"column", gap:16 }}>
                <div style={{ width:72, height:72, background:"rgba(0,85,164,0.08)", borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", fontSize:36 }}>✅</div>
                <h3 style={{ fontSize:26, fontWeight:900, color:"#191c1d", fontFamily:"Outfit,sans-serif" }}>Message Sent!</h3>
                <p style={{ color:"#5d3f3b", lineHeight:1.7, fontFamily:"Outfit,sans-serif" }}>Thank you for reaching out. We'll get back to you within 1 business day.</p>
              </div>
            ):(
              <form onSubmit={handleSubmit} style={{ display:"flex", flexDirection:"column", gap:20 }}>
                <div>
                  <h3 style={{ fontSize:24, fontWeight:900, color:"#191c1d", margin:"0 0 6px", letterSpacing:"-0.02em", fontFamily:"Outfit,sans-serif" }}>Send us a Message</h3>
                  <p style={{ color:"#999", fontSize:14, margin:0, fontFamily:"Outfit,sans-serif" }}>We'll respond within 1 business day.</p>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                    {[{ id: "firstName", label: "First Name" }, { id: "lastName", label: "Last Name" }].map(f => (
                      <div key={f.id}>
                        <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#4a4a4a", marginBottom: 6, letterSpacing: "0.07em", textAlign: "left" }}>{f.label}</label>
                        <input type="text" required value={formData[f.id]}
                          onChange={e => setFormData({ ...formData, [f.id]: e.target.value })}
                          style={{ width: "100%", padding: "12px 14px", border: "1.5px solid #e7e8e9", borderRadius: 10, fontSize: 14, outline: "none", fontFamily: "inherit", transition: "border 0.2s" }}
                          onFocus={e => { e.target.style.borderColor = "#0055A4"; }}
                          onBlur={e => { e.target.style.borderColor = "#e7e8e9"; }}
                        />
                      </div>
                  ))}
                </div>
                  <div>
                    <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#4a4a4a", marginBottom: 6, letterSpacing: "0.07em", textAlign: "left" }}>Email Address</label>
                    <input type="email" required value={formData.email}
                      onChange={e => setFormData({ ...formData, email: e.target.value })}
                      style={{ width: "100%", padding: "12px 14px", border: "1.5px solid #e7e8e9", borderRadius: 10, fontSize: 14, outline: "none", fontFamily: "inherit", transition: "border 0.2s" }}
                      onFocus={e => { e.target.style.borderColor = "#0055A4"; }}
                      onBlur={e => { e.target.style.borderColor = "#e7e8e9"; }}
                    />
                  </div>
                <div>
                    <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#4a4a4a", marginBottom: 6, letterSpacing: "0.07em", textAlign: "left" }}>Message</label>
                    <textarea required rows={5} value={formData.message}
                      onChange={e => setFormData({ ...formData, message: e.target.value })}
                      style={{ width: "100%", padding: "12px 14px", border: "1.5px solid #e7e8e9", borderRadius: 10, fontSize: 14, outline: "none", fontFamily: "inherit", resize: "vertical", transition: "border 0.2s" }}
                      onFocus={e => { e.target.style.borderColor = "#0055A4"; }}
                      onBlur={e => { e.target.style.borderColor = "#e7e8e9"; }}
                    />
                  </div>
                <button type="submit" style={{ background:"linear-gradient(135deg,#D30D0D,#a70004)", color:"#fff", border:"none", borderRadius:10, padding:"15px 24px", fontWeight:700, fontSize:15, cursor:"pointer", fontFamily:"Outfit,sans-serif", boxShadow:"0 6px 20px rgba(211,13,13,0.3)", transition:"transform 0.25s,box-shadow 0.25s" }}
                  onMouseEnter={e=>{e.target.style.transform="translateY(-2px)";e.target.style.boxShadow="0 12px 32px rgba(211,13,13,0.4)";}}
                  onMouseLeave={e=>{e.target.style.transform="translateY(0)";e.target.style.boxShadow="0 6px 20px rgba(211,13,13,0.3)";}}
                >Send Message →</button>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* ── FOOTER ─────────────────────────────────────────────────────────── */}
      <footer style={{ width:"100vw", background:"#08080f", padding:"44px 5%" }}>
        <div className="sf-fi" style={{ display:"flex", flexWrap:"wrap", justifyContent:"space-between", alignItems:"center", gap:24 }}>
          {/* Logo */}
          {!logoError
              ? <img src={LOGO_URL} alt="SuretyFox" style={{ height:95, width:"auto", objectFit:"contain" }} onError={()=>setLogoError(true)}/>
              : <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                  <div style={{ width:38, height:38, background:"linear-gradient(135deg,#D30D0D,#a70004)", borderRadius:8, display:"flex", alignItems:"center", justifyContent:"center" }}>
                    <span style={{ color:"#fff", fontWeight:900, fontSize:20 }}>S</span>
                  </div>
                  <span style={{ fontWeight:900, fontSize:20, color:"#D30D0D", fontFamily:"Outfit,sans-serif" }}>SURETY</span>
                  <span style={{ fontWeight:900, fontSize:20, color:"#0055A4", fontFamily:"Outfit,sans-serif" }}>FOX</span>
                </div>
            }
          {/* Footer links */}
          <div style={{ display:"flex", gap:28, flexWrap:"wrap", alignItems:"center" }}>
            {[
              { label:"Privacy Policy",   action:()=>setModal("privacy")          },
              { label:"Terms of Service", action:()=>setModal("terms")            },
              { label:"Claims Support",   action:()=>scrollTo("contact")          },
              { label:"Rider Safety",     action:()=>{}                           },
            ].map(item=>(
              <button key={item.label} onClick={item.action} style={{ background:"none", border:"none", cursor:"pointer", color:"rgba(255,255,255,0.45)", fontSize:11, fontWeight:600, letterSpacing:"0.1em", textTransform:"uppercase", fontFamily:"Outfit,sans-serif", transition:"color 0.2s" }}
                onMouseEnter={e=>{e.target.style.color="#ff7070";}}
                onMouseLeave={e=>{e.target.style.color="rgba(255,255,255,0.45)";}}
              >{item.label}</button>
            ))}
          </div>
          <p style={{ color:"rgba(255,255,255,0.22)", fontSize:11, margin:0, textTransform:"uppercase", letterSpacing:"0.08em", fontFamily:"Outfit,sans-serif" }}>© 2025 SuretyFox Tech Pvt. Ltd.</p>
        </div>
      </footer>

      {/* ── MODALS ─────────────────────────────────────────────────────────── */}
      {modal&&(
        <Modal title={POLICY[modal].title} sections={POLICY[modal].sections} onClose={()=>setModal(null)}/>
      )}
    </>
  );
}